import { getEmissionsByUserLogic } from "./Emissions.logic";
import { saveEmissionsData } from "../Infrastructure/Emissions.store";

export async function getEmissionsByUser(years = []) {
  const emissionsPerYear = await getEmissionsByUserLogic(years);
  saveEmissionsData(emissionsPerYear);
  return emissionsPerYear;
}
